module.exports = __webpack_public_path__ + "assets/arrow-top_icon.4b1b41de.svg";